import Phaser from 'phaser'

export default class PauseScene extends Phaser.Scene {
  create () {
    this.background = this.add.image(640, 0, 'white').setOrigin(0.5, 0).setDisplaySize(this.scale.width, this.scale.height).setAlpha(0.75).setTint(0)

    const width = this.scale.width
    this.add.image(640, 400, 'white').setTint(0).setDisplaySize(width * 1.4, 200).setRotation(0.04)
    this.add.image(640, 400, 'hud', 'paused')

    const enter = this.add.image(640, 620, 'hud', 'press_enter')
    this.tweens.add({
      targets: enter,
      scale: 1.05,
      yoyo: true,
      repeat: -1
    })

    const goBackToGame = () => {
      this.scene.resume('GameScene')
      this.scene.sleep()
    }

    this.input.keyboard.on('keyup-ENTER', () => {
      goBackToGame()
    })
    this.input.on('pointerdown', () => {
      goBackToGame()
    })

    this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
    this.scale.on('resize', () => {
      if (this.cameras.main) {
        this.cameras.main.scrollX = -(this.scale.width - 1280) / 2
        this.background.setDisplaySize(this.scale.width, this.scale.height)
      }
    })
  }
}
